import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CourseForm from '../../../components/forms/CourseForm';
import { useCourseApi } from '../../../hooks/useCourseApi';
import { useNavigate, useParams } from 'react-router-dom';
import { CourseDTO } from '../../../services/apiClient';
import { getRoles } from '../../../utils/tokenUtils';

const CourseEdit: React.FC = () => {
  const { getById, edit } = useCourseApi();
  const [entityData, setEntityData] = useState<CourseDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const roles = getRoles();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Courses', href: '/admin/dedicatedstatus' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Course data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      handleNavigate();
    } catch (error) {
      console.error('Error updating Course:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/dedicatedstatus"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission='Manage.Course.Edit'
    >
        {entityData ? (
          <CourseForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={handleNavigate}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CourseEdit;